import React, { useContext, useState } from "react";
import CustomerInfo, {
  ICustomerData,
} from "../../components/signup/customer-info";
import VerifyNumber from "../../components/signup/verify-number";
import { useLocation } from "react-router-dom";
import SignUpLayout from "../../components/signup/layout";
import useAppNavigate from "../../components/router/use-app-navigate";
import FileApi from "../../api/file";
import AuthContext from "../../components/auth-context";

export interface ISignupProps {
  medium?: number;
}

export interface UserData {
  name: string | null;
  code: number | null;
  isSupportUser: boolean;
}

export default function SignUp({ medium }: ISignupProps) {
  const location = useLocation();
  const context = useContext(AuthContext);
  const [customerData, setCustomerData] = useState<ICustomerData | undefined>();
  const [alert, setAlert] = useState<boolean>(false);
  const navigate = useAppNavigate();
  const [userData, setUserData] = useState<UserData>({
    name: null,
    code: null,
    isSupportUser: false,
  });

  function onCustomerInfoSubmit(data: ICustomerData) {
    setCustomerData(data);
  }

  const handleAlert = (result: boolean) => {
    setAlert(result);
  };

  function onVerifyNumberSubmit(authId: string) {
    if (location.pathname === "/signup/ngn")
      navigate(`/signup/ngn/uploadImage`);
    else {
      context.authId = authId;
      new FileApi(context)
        .post(
          customerData!.type,
          customerData!.phone ?? "",
          customerData?.subCenterId ?? "",
          userData.code?.toString() ??
            customerData?.agentCode?.toString() ??
            "",
          "Owner",
          "",
          ""
        )
        .then(({ errorMessage, id }) => {
          if (!errorMessage) {
            context.setActiveFileId(id);
          } else {
            console.log("File upload error:", errorMessage); // Handle error accordingly
          }
          navigate(`/signup/uploadImage`);
        });
    }
  }

  const handleAgentDataChange = (data: UserData) => {
    setUserData(data);
    context.setUserData(data);
  };

  return (
    <SignUpLayout step={customerData ? 2 : 1} type={medium} steps={[1, 2, 3]}>
      {customerData ? (
        <VerifyNumber
          username={customerData.username}
          onSubmit={onVerifyNumberSubmit}
          handleAlert={handleAlert}
          alert={alert}
          serviceType={customerData.serviceType}
        />
      ) : (
        <CustomerInfo
          type={medium}
          onSubmit={onCustomerInfoSubmit}
          handleAgentDataChange={handleAgentDataChange}
        />
      )}
    </SignUpLayout>
  );
}
